<template>
	<div class="o-dashboard">
		<c-table v-if="endpoint"
			:small="true"
			:endpoint="endpoint"
			:columns="columns"
            :search="false">
		</c-table>
	</div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';

export default {
	mixins: [ View, Form ],
	components: { CTable },
	data(){
			return {
				endpoint: ''
			}
		},
	computed: {
		
		columns() {
			return [
				{ name: 'created_at', label: 'Datum', component: 'CColumnDatetime', sortable: true, sort: true },
				{ name: 'created_at', label: 'Tijd', component: 'CColumnTime', sortable: true },
				{ name: 'status.name', label: 'Omschrijving', sortable: true },
				{ name: 'product.name', label: 'Artikel', sortable: true },
			];
		},
	},
	mounted(){
		if(this.$route.name == 'activitiesRepair'){
			this.endpoint = '/api/geteventsbyrepairid/' + this.$route.params.id;
		}
		else {
			this.endpoint = '/api/geteventsbyclientid/' + this.$route.params.id;
		}
	}
}
</script>